// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"deleteLabel_confirmButton__3WwBo","cancelButton":"deleteLabel_cancelButton__27MXz","buttonsContainer":"deleteLabel_buttonsContainer__1rtSu"};